import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BottomSheet } from "@/ui/components";
import { Button } from "@/ui/components/Button";
import { ArrowRightIcon } from "@/assets/icons";
import { externalUrls } from "@/constants/urls";
import { routes } from "@/routes/routes";
import VoltAppIcon from "@/assets/logos/volt-app-icon.svg";
import styles from "./CnpInUseModal.module.scss";


export function useCnpInUseModal() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [maskedPhone, setMaskedPhone] = useState("");

  const open = useCallback((phone: string) => {
    setMaskedPhone(phone);
    setIsOpen(true);
  }, []);
  const close = useCallback(() => setIsOpen(false), []);

  const title = "CNP deja utilizat";
  const description = `Acest CNP este deja utilizat de o altă persoană care are numărul de telefon ${maskedPhone}. Dacă acesta este numărul tău, te rugăm să te loghezi cu el.

Dacă nu ai acces la acel număr, poți continua în aplicația Volt pentru a-ți verifica identitatea și a continua aplicarea pentru un credit`;

  const handleVerifyInApp = () => {
    window.location.href = externalUrls.volt.appDownload;
  };

  const handleLogin = () => {
    setIsOpen(false);
    navigate(routes.public.logout);
  };

  const content = (
    <div className={styles.content}>
      <VoltAppIcon className={styles.appIcon} />
      <div className={styles.textContent}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );

  const footer = (
    <div className={styles.footer}>
      <Button
        trackingId="cnp_in_use_verify_in_app"
        variant="filled"
        text="Verifică identitatea în Volt"
        rightIcon={<ArrowRightIcon />}
        className={styles.button}
        onClick={handleVerifyInApp}
      />
      <Button
        trackingId="cnp_in_use_login"
        variant="outlined"
        text={`Autentifică-te cu ${maskedPhone}`}
        className={styles.button}
        onClick={handleLogin}
      />
    </div>
  );

  return {
    open,
    close,
    modal: (
      <BottomSheet
        open={isOpen}
        onOpenChange={setIsOpen}
        ariaLabel={title}
        ariaDescription={description}
        enableDrag
        closeOnOverlay
        footer={footer}
      >
        {content}
      </BottomSheet>
    ),
  };
}
